import * as React from 'react';
import { Col, Offcanvas, Row } from 'react-bootstrap';
import { DataPoint } from 'Interfaces/DataPoint';
import { useAppSelector } from 'index';
import { uniqueFormsSelector } from 'reducers/formsReducer';
import CardView from '../CardView';

interface Props {
  formId: string;
  dataPoints: DataPoint[];
  show: boolean;
  onHide: () => void;
}

export default function CardsViewer(props: Props) {
  const { formId, dataPoints, show, onHide } = props;
  const form = useAppSelector(state => uniqueFormsSelector(state)).find(f => f.ref === formId);

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="bottom"
      backdrop={false}
      scroll={true}
      className="h-50"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {form ? `${form.name} (${dataPoints.length})` : ''}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {form
          ? (
            <Row>
              {(dataPoints.map(dp => (
                <Col key={dp.id} className="mb-3 pb-3 border-bottom">
                  <CardView form={form} dataPoint={dp} />
                </Col>))
              )}
            </Row>
          ) : <div>Form not found</div>}
      </Offcanvas.Body>
    </Offcanvas>
  );
}
